<div
	*ngIf="selectedPin?.parent"
	class="flex flex-1 justify-between bg-grey-lightest border-grey-veryLight border rounded-md"
>
	<div class="flex flex-1">
		<div
			*ngIf="selectedPin?.partLot"
			class="flex flex-1 flex-col justify-center items-center"
			matTooltip="Part Lot"
		>
			<app-icon
				[icon]="ICON.INTEGRATED"
				class="text-yellow-500 text-md"
				[testHook]="testHooks.IntegratedIcon"
			></app-icon>
		</div>
		<div
			*ngIf="!selectedPin?.partLot"
			class="flex flex-1 flex-col justify-center items-center"
			matTooltip="Full Lot"
		>
			<app-icon
				[icon]="ICON.HOME"
				class="text-green-300 text-md"
				[testHook]="testHooks.HomeIcon"
			></app-icon>
		</div>
		<div
			class="flex flex-1 flex-col justify-center items-center cursor-pointer"
			[matTooltip]="selectedPin?.map ? 'Map purchased' : 'Purchase map'"
			(click)="goToMap()"
			[testHook]="testHooks.GoToMapDiv"
		>
			<app-icon
				[icon]="ICON.MAP"
				class="text-md"
				[ngClass]="{
					'text-green-300': selectedPin?.map,
					'text-gray-200': !selectedPin?.map,
				}"
				[testHook]="testHooks.MapIcon"
			></app-icon>
		</div>
		<div
			class="flex flex-1 flex-col justify-center items-center cursor-pointer"
			matTooltip="Adjacent PINs purchase"
			(click)="goToMap()"
			[testHook]="testHooks.GoToMapDiv1"
		>
			<app-icon
				[icon]="ICON.CITY"
				class="text-md"
				[ngClass]="{
					'text-green-300': purchasedAdjacentPins,
					'text-gray-200': !purchasedAdjacentPins,
				}"
				[testHook]="testHooks.CityIcon"
			></app-icon>
		</div>
		<div
			*ngIf="purchasedAdjacentPins"
			class="flex flex-1 items-center cursor-pointer"
			(click)="openSimilarNamesModal()"
			[testHook]="testHooks.OpenSimilarNamesModalDiv"
		>
			<div
				*ngIf="selectedPin?.sameAdjacentOwners"
				class="flex flex-1 flex-col justify-center items-center"
				matTooltip="Adjacent PINs have similarily named owners"
			>
				<app-icon
					[icon]="ICON.PARTIES"
					class="text-yellow-500"
					[testHook]="testHooks.PartiesIcon"
				></app-icon>
			</div>
			<div
				*ngIf="!selectedPin?.sameAdjacentOwners"
				class="flex flex-1 flex-col justify-center items-center"
				matTooltip="Adjacent PINs do not have similarily named owners"
			>
				<app-icon
					[icon]="ICON.PARTIES"
					class="text-green-300 text-md"
					[testHook]="testHooks.PartiesIcon1"
				></app-icon>
			</div>
		</div>
		<div
			class="flex flex-1 flex-col justify-center items-center cursor-pointer"
			matTooltip="Pin data synced with the file"
			(click)="goToSync()"
			[testHook]="testHooks.GoToSyncDiv"
		>
			<app-icon
				[icon]="ICON.REFRESH"
				class="text-md"
				[ngClass]="{
					'text-green-300': selectedPin.synced,
					'text-gray-200': !selectedPin.synced,
				}"
				[testHook]="testHooks.RefreshIcon"
			></app-icon>
		</div>
		<div *ngIf="parcelInstrumentsDiffer !== null" class="flex flex-1">
			<div
				*ngIf="parcelInstrumentsDiffer"
				class="flex flex-1 flex-col justify-center items-center"
				matTooltip="Latest Instrument Numbers do not match"
			>
				<app-icon
					[icon]="ICON.EXCLAMATION"
					class="text-md text-yellow-500"
					[testHook]="testHooks.ExclamationIcon"
				></app-icon>
			</div>
			<div
				*ngIf="!parcelInstrumentsDiffer"
				class="flex flex-1 flex-col justify-center items-center"
				matTooltip="Latest Instrument Numbers match"
			>
				<app-icon
					[icon]="ICON.CHECK"
					class="text-md text-green-300"
					[testHook]="testHooks.CheckIcon"
				></app-icon>
			</div>
		</div>
	</div>
</div>
